export function extractNumberFromString(text) {
  const matches = text.match(/\d+/);
  return matches ? parseInt(matches[0], 10) : null;
}

export function getGroupedData(data, groupKey) {
  const groupedData = {};

  data?.forEach((item) => {
    const groupedKey = item[groupKey];

    // If groupedKey is not in the result, add it
    if (!groupedData[groupedKey]) {
      groupedData[groupedKey] = item;
    }
  });

  // Convert the result to an array of unique models_id
  const uniqueGroupedData = Object.values(groupedData);

  return uniqueGroupedData;
}


export function getImageUrl(url) {
  if (!url) {
    return window.DEFAULT_IMAGE_URL;
  }

  if (url.indexOf('dyno-chiptuningfiles.com') >= 0) {
    return window.DEFAULT_IMAGE_URL;
  }

  return url;
}
